import { useParams } from 'react-router-dom';
import { IntegrationDetailModule, getIntegration } from '../modules/integrations';
import { StartupSubPageShell } from './StartupSubPageShell';

/**
 * Integration permissions page (`/:startupSlug/integrations/:toolId`). Reuses the
 * startup sub-page shell with the Integrations nav highlighted; back goes to the
 * integrations list and the header shows a "Integrations / {Name}" breadcrumb.
 */
export default function StartupIntegrationDetailPage(): JSX.Element {
  const { toolId } = useParams<{ toolId: string }>();
  const name = getIntegration(toolId)?.name ?? 'Integration';

  return (
    <StartupSubPageShell
      activeSection="integrations"
      headerTitle={`Integrations / ${name}`}
      backTo={(slug) => `/${slug}/integrations`}
    >
      {() => <IntegrationDetailModule />}
    </StartupSubPageShell>
  );
}
